module.exports = __webpack_public_path__ + "static/media/agricultural2.e7b42cc8.jpg";